import React, {Fragment, ReactNode, useRef} from "react";
import {
    arrow,
    autoUpdate,
    type ExtendedRefs,
    flip,
    FloatingArrow,
    FloatingFocusManager,
    offset,
    type Placement,
    shift,
    useFloating,
    useInteractions,
    useTransitionStyles
} from "@floating-ui/react";
import classNames from "classnames";

import {getMessageColor, IMessageType, Message} from "@pg-design/message-module";

import * as cns from "./ManualPopover.module.css";

interface IProps {
    children: ({refs, getReferenceProps}: {refs: ExtendedRefs<unknown>; getReferenceProps: () => Record<string, unknown>}) => ReactNode;
    isOpen: boolean;
    handleSetIsOpen: (isOpen: boolean) => void;
    className?: string;
    placement?: Placement;
    popover: ReactNode | string;
    hideArrow?: boolean;
    type?: IMessageType;
}

/**
 * ManualPopover is a simple "popover" version, that is not bound to any automatic trigger,
 * but rather is controlled by the parent component.
 * @param props
 * @constructor
 */
export function ManualPopover(props: IProps) {
    const {children, className, placement, popover, type, isOpen, handleSetIsOpen, hideArrow} = props;

    const arrowRef = useRef<SVGSVGElement | null>(null);

    const {refs, floatingStyles, context} = useFloating({
        open: isOpen,
        onOpenChange(isOpen) {
            handleSetIsOpen(isOpen);
        },
        placement: placement || "bottom",
        middleware: [offset(10), flip({fallbackAxisSideDirection: "end"}), shift(), arrow({element: arrowRef})],
        whileElementsMounted: autoUpdate
    });

    const {isMounted, styles: transitionStyles} = useTransitionStyles(context, {
        duration: 200
    });
    const {getReferenceProps, getFloatingProps} = useInteractions();

    const arrowConfig = hideArrow
        ? undefined
        : {
              fill: getMessageColor(type)
          };

    return (
        <Fragment>
            {children({refs, getReferenceProps})}

            {isMounted && (
                <FloatingFocusManager context={context} modal={false}>
                    <div className={classNames(className, cns.manualPopoverFloating)} ref={refs.setFloating} style={floatingStyles} {...getFloatingProps()}>
                        <div style={transitionStyles}>
                            {typeof popover === "string" ? <Message type={type}>{popover}</Message> : popover}
                            {arrowConfig ? <FloatingArrow ref={arrowRef} width={32} context={context} fill={arrowConfig.fill} /> : null}
                        </div>
                    </div>
                </FloatingFocusManager>
            )}
        </Fragment>
    );
}
import React, {Fragment, ReactNode, useRef} from "react";
import {
    arrow,
    autoUpdate,
    type ExtendedRefs,
    flip,
    FloatingArrow,
    FloatingFocusManager,
    offset,
    type Placement,
    shift,
    useFloating,
    useInteractions,
    useTransitionStyles
} from "@floating-ui/react";
import classNames from "classnames";

import {getMessageColor, IMessageType, Message} from "@pg-design/message-module";

import * as cns from "./ManualPopover.module.css";

interface IProps {
    children: ({refs, getReferenceProps}: {refs: ExtendedRefs<unknown>; getReferenceProps: () => Record<string, unknown>}) => ReactNode;
    isOpen: boolean;
    handleSetIsOpen: (isOpen: boolean) => void;
    className?: string;
    placement?: Placement;
    popover: ReactNode | string;
    hideArrow?: boolean;
    type?: IMessageType;
}

/**
 * ManualPopover is a simple "popover" version, that is not bound to any automatic trigger,
 * but rather is controlled by the parent component.
 * @param props
 * @constructor
 */
export function ManualPopover(props: IProps) {
    const {children, className, placement, popover, type, isOpen, handleSetIsOpen, hideArrow} = props;

    const arrowRef = useRef<SVGSVGElement | null>(null);

    const {refs, floatingStyles, context} = useFloating({
        open: isOpen,
        onOpenChange(isOpen) {
            handleSetIsOpen(isOpen);
        },
        placement: placement || "bottom",
        middleware: [offset(10), flip({fallbackAxisSideDirection: "end"}), shift(), arrow({element: arrowRef})],
        whileElementsMounted: autoUpdate
    });

    const {isMounted, styles: transitionStyles} = useTransitionStyles(context, {
        duration: 200
    });
    const {getReferenceProps, getFloatingProps} = useInteractions();

    const arrowConfig = hideArrow
        ? undefined
        : {
              fill: getMessageColor(type)
          };

    return (
        <Fragment>
            {children({refs, getReferenceProps})}

            {isMounted && (
                <FloatingFocusManager context={context} modal={false}>
                    <div className={classNames(className, cns.manualPopoverFloating)} ref={refs.setFloating} style={floatingStyles} {...getFloatingProps()}>
                        <div style={transitionStyles}>
                            {typeof popover === "string" ? <Message type={type}>{popover}</Message> : popover}
                            {arrowConfig ? <FloatingArrow ref={arrowRef} width={32} context={context} fill={arrowConfig.fill} /> : null}
                        </div>
                    </div>
                </FloatingFocusManager>
            )}
        </Fragment>
    );
}
